import { Component } from "react";
import { Button, Col, Form, InputGroup, Modal } from "react-bootstrap";
import axiosInstance from "../../../axiosInstance";
import "../../../css/NewTicket.css"
import '@fortawesome/fontawesome-free/css/all.min.css';
import { logOut, make_select_data } from "../../helper";
import { Link, withRouter } from "react-router-dom";
import Select from 'react-select'




class ChildTicket extends Component {

    constructor(props) {
        super(props);
        this.state = {
            types_filters_array: [],
            permissions: [],
            account_id: '',
            first_name: '',
            second_name: '',
            personal_number: '',
            address: '',
            type_id: null,
            phone: '',
            sec_phone: '',
            comment: '',
            city: '',
            stages: [],
            stage: null,
            tv_brands: [],
            tv_brand: null,
            tv_brand_label: "",
            internet_speed: "",
            problems_array: [],
            selected_problem_id: null,
            quantity: 1,
            consumer_id: null,
            errors: {
                account_id: false,
                first_name: false,
                second_name: false,
                type: false,
                city: false,
                personal_number: false,
                stage: false

            },
            modal: false,
            error_messages: {
                billing_error_message: 'გთხოვთ შეიყვანოთ საბილინგო ნომერი',
                first_name_error_message: 'გთხოვთ შეიყვანოთ სახელი',
                second_name_error_message: 'გთხოვთ შეიყვანოთ გვარი',
                phone_error_message: 'გთხოვთ შეიყვანოთ მობილური',
                address_error_message: 'გთხოვთ შეიყვანოთ მისამართი',
                city_error_message: 'გთხოვთ შეიყვანოთ ქალაქი',
                personal_number_error_message: 'გთხოვთ შეიყვანოთ პირადი ნომერი',
                type_select_error_message: 'გთხოვთ აირჩიოთ ტიპი',
                stage_select_error_message: 'გთხოვთ აირჩიოთ მდგომარეობა'
            }
        }
    }
    componentDidMount() {
        this.fetch_filter_types();
        this.fetch_tv_brands();
        this.fetch_problems();
        this.fetch_ticket_by_id();
        this.fetch_filter_stages();
    }

    onChange(event) {
        this.setState(
            {
                [event.target.name]: event.target.value,
                errors: {
                    ...this.state.errors,
                    [event.target.name]: false
                }
            }
        )
    }


    fetch_ticket_by_id() {
        axiosInstance.get("tickets/" + this.props.match.params.id)
            .then(response => this.afterTicketFetch(response.data.data))
            .catch(err => {
                if (err.response != null) {
                    if (err.response.status === 401) {
                        this.logout();
                    }
                    if (err.response.status === 400) {
                        this.setState({
                            ...this.state,
                            errors: {
                                ...this.state.errors,
                                account_id: true
                            },
                            error_messages: {
                                ...this.state.error_messages,
                                billing_error_message: 'მონაცემები ვერ მოიძებნა'
                            }
                        })
                    }
                }

            })
    }

    afterTicketFetch(data) {
        this.setState({
            account_id: data.account_id,
            first_name: data.first_name,
            second_name: data.second_name,
            personal_number: data.personal_number,
            address: data.address,
            type_id: null,
            phone: data.phone,
            city: data.city,
            stages: [],
            stage: null,
            tv_brand: data.tv_brand_id,
            tv_brand_label: data.tv_brand,
            internet_speed: data.internet_speed,
            quantity: data.quantity,
            consumer_id: data.consumer_id,
            sec_phone: data.second_phone
        })
    }



    valid() {
        var firstname = (this.state.first_name === '');
        var secondname = (this.state.second_name === '');
        var address = (this.state.address === '');
        var phone = (this.state.address === '');
        var city = (this.state.city === '')
        var personal_number = (this.state.personal_number === '')
        var type = (this.state.type_id === null);
        var stage = (this.state.stage === null);
        if (firstname || secondname || address || phone || personal_number || type || stage) {
            this.setState({
                errors: {
                    first_name: firstname,
                    second_name: secondname,
                    address: address,
                    phone: phone,
                    city: city,
                    personal_number: personal_number,
                    type: type,
                    stage: stage
                },
                error_messages: {
                    ...this.state.error_messages,
                    billing_error_message: 'გთხოვთ შეიყვანოთ საბილინგო ნომერი'
                }
            })
            return false;
        }
        return true;
    }


    afterInsert(data) {
        this.setState({
            ...this.state,
            modal: true
        })
    }

    sendData() {
        var data = new FormData();
        var data = {
            account_id: this.state.account_id,
            first_name: this.state.first_name,
            second_name: this.state.second_name,
            personal_number: this.state.personal_number,
            city: this.state.city,
            address: this.state.address,
            phone: this.state.phone,
            second_phone: this.state.sec_phone,
            tv_brand_id: this.state.tv_brand,
            problem_id: this.state.selected_problem_id,
            type_id: this.state.type_id,
            stage_id: this.state.stage,
            internet_speed: this.state.internet_speed,
            quantity: this.state.quantity,
            text: this.state.comment
        }
        if (this.valid()) {
            axiosInstance.post('/tickets', data)
                .then(response => this.setState({
                    modal: true
                }))
                .catch(function (error) {
                    console.log(error);
                });
        }
    }

    afterBillingFetch(data) {
        this.setState({
            ...this.state,
            first_name: data.data.first_name,
            second_name: data.data.second_name,
            address: data.data.address,
            phone: data.data.phone,
            city: data.data.city,
            personal_number: data.data.personal_number
        })
    }


    logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        this.props.history.push('/login')
    }

    fetchBillingInfo() {
        if (this.state.account_id === '') {
            this.setState({
                errors: {
                    ...this.state.errors,
                    account_id: true
                }
            })
            return;
        }
        axiosInstance.get("tickets/billing/info/" + this.state.account_id)
            .then(data => this.afterBillingFetch(data))
            .catch(err => {
                console.log(err)
                if (err.response != null) {
                    if (err.response.status === 401) {
                        this.logout();
                    }
                    if (err.response.status === 400) {
                        this.setState({
                            ...this.state,
                            errors: {
                                ...this.state.errors,
                                account_id: true
                            },
                            error_messages: {
                                ...this.state.error_messages,
                                billing_error_message: 'მონაცემები ვერ მოიძებნა'
                            }
                        })
                    }
                }

            })
    }

    make_type_items() {
        let arr = [];
        this.state.types_filters_array.forEach(element => {
            arr.push(<option value={element.id} key={element.id}>{element.display_name}</option>)
        });
        return arr;
    }

    on_type_fetch(data) {
        this.setState({
            types_filters_array: data
        })
    }

    fetch_filter_types() {
        axiosInstance.get('tickets/types/auth')
            .then(response => {
                this.setState({
                    types_filters_array: make_select_data(response.data.data)
                })
            })
            .catch(err => {
                if (err.response.status === 401) {
                    logOut(this.props);
                }
            })

    }

    on_tv_brands_fetch(data) {
        var brands_array = [];
        data.forEach(function (element) {
            brands_array.push({
                value: element.id,
                label: element.display_name
            })
        });

        this.setState({
            tv_brands: brands_array
        });
    }

    fetch_tv_brands() {
        axiosInstance.get('/tv_brands')
            .then(response => {
                this.setState({
                    tv_brands: make_select_data(response.data.data)
                })
            })
            .catch(err => {
                console.log(err.response)
                if (err.response.status === 401) {
                    logOut(this.props);
                }
            })
    }

    on_tv_brand_change(e) {
        this.setState({
            tv_brand: e.value
        })
    }


    on_type_change(e) {
        let type_id = parseInt(e.target.value)
        this.setState({
            type_id: type_id
        })

    }


    fetch_filter_stages(){
        axiosInstance.get('tickets/stages/inside/')
        .then(response=>{
            this.setState({
                stages_filters_array:make_select_data(response.data.data)
            })
        })
        .catch(err => {
            console.log(err.response)
            if(err.response.status === 401){
                logOut(this.props);
            }
        })
    }

    fetch_problems() {
        axiosInstance.get('/tickets/problems')
            .then(response => {
                this.setState({
                    problems_array: make_select_data(response.data.data)
                })
            })
            .catch(err => {
                console.log(err.response)
                if (err.response.status === 401) {
                    logOut(this.props);
                }
            })
    }

    on_stage_change(e) {
        let stage_id = parseInt(e.value)
        this.setState({
            stage: stage_id
        })
    }

    on_problem_change(e) {
        this.setState({
            selected_problem_id: e.value
        })
    }

    modalClose() {
        window.location.reload();
    }

    type_filter_changed(e) {
        let type_id = parseInt(e.value)
        this.setState({
            type_id: type_id
        })

    }
    render() {
        const defaultValueBrand = { label: this.state.tv_brand_label, value: this.state.tv_brand }
        return (
            <div className="new-ticket-container">
                <div className="user-info-container">
                    <Form.Row >
                        <Form.Group as={Col} md="4" controlId="validationFormik03">
                            <Form.Label>საბილინგო ნომერი</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type="number"
                                    name="account_id"
                                    onChange={(event) => this.onChange(event)}
                                    isInvalid={Boolean(this.state.errors.account_id)}
                                    value={this.state.account_id}
                                    disabled={true}
                                />
                            </InputGroup>
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="validationFormik01">
                            <Form.Label>სახელი</Form.Label>
                            <Form.Control
                                type="text"
                                name="first_name"
                                onChange={(event) => this.onChange(event)}
                                isInvalid={Boolean(this.state.errors.first_name)}
                                value={this.state.first_name}
                                disabled={true}
                            />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.error_messages.first_name_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="validationFormik02">
                            <Form.Label>გვარი</Form.Label>
                            <Form.Control
                                type="text"
                                name="second_name"
                                onChange={(event) => this.onChange(event)}
                                isInvalid={Boolean(this.state.errors.second_name)}
                                value={this.state.second_name}
                                disabled={true}
                            />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.error_messages.second_name_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} md="4" controlId="validationCustomUsername">
                            <Form.Control
                                type="number"
                                name="sec_phone"
                                onChange={null}
                                isInvalid={Boolean(this.state.errors.type)}
                                hidden={true}
                            />
                            <Form.Label>ტიპი</Form.Label>
                            <Select options={this.state.types_filters_array} onChange={(e) => this.type_filter_changed(e)} />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.error_messages.type_select_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="2" >
                            <Form.Label>რაოდენობა</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type="number"
                                    name="quantity"
                                    defaultValue={1}
                                    onChange={(event) => this.onChange(event)}
                                />
                            </InputGroup>
                        </Form.Group>
                        <Form.Group as={Col} md="2"  >
                            <Form.Label>პრობლემა</Form.Label>
                            <Select
                                options={this.state.problems_array}
                                onChange={(e) => this.on_problem_change(e)}
                                placeholder="აირჩიეთ" />
                        </Form.Group>

                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} md="4" controlId="validationCustomUsername">
                            <Form.Control
                                type="number"
                                name="sec_phone"
                                onChange={null}
                                isInvalid={Boolean(this.state.errors.stage)}
                                hidden={true}
                            />
                            <Form.Label>მდგომარეობა</Form.Label>
                            <Select options={this.state.stages_filters_array} onChange={(e) => this.on_stage_change(e)} />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.error_messages.stage_select_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="6" controlId="validationFormik05">
                            <Form.Label>კომენტარი</Form.Label>
                            <Form.Control
                                type="text"
                                name="comment"
                                onChange={(event) => this.onChange(event)}
                                value={this.state.comment}
                            />
                        </Form.Group>


                    </Form.Row>
                    <Link to="/dashboard" id="btn-back" className="btn btn-dark" >უკან დაბრუნება</Link>
                    <Button className="btn btn-success" size="md" onClick={(event) => this.sendData(event)}>დამატება</Button>
                    <Modal show={this.state.modal} centered>
                        <Modal.Body>
                            მონაცემი წარმატებით ჩაემატა!
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="success" onClick={(event) => this.modalClose(event)} >
                                ok
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>

        )
    }
}

export default withRouter(ChildTicket)